/* Grocery locale nudge: first-visit offer to view the store in Urdu.
 * Slim non-blocking bottom bar. Appears only after the first scroll,
 * only when navigator.language starts with "ur" and no stored
 * preference exists. Never redirects; never re-asks once dismissed.
 * Vanilla JS, no external requests.
 */
(function () {
  var STORAGE_KEY = 'grocery-locale-choice';

  function stored() {
    try {
      return window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function remember(value) {
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {}
  }

  function browserPrefersUrdu() {
    var langs = window.navigator.languages || [window.navigator.language];
    for (var i = 0; i < langs.length; i++) {
      if (typeof langs[i] === 'string' && langs[i].toLowerCase().indexOf('ur') === 0) return true;
    }
    return false;
  }

  function init() {
    var nudge = document.querySelector('[data-locale-nudge]');
    if (!nudge) return;
    if (stored()) return;
    if (!browserPrefersUrdu()) {
      remember('seen-en');
      return;
    }

    var shown = false;
    function show() {
      if (shown) return;
      shown = true;
      nudge.hidden = false;
    }

    function onScroll() {
      if (window.scrollY > 120) {
        show();
        window.removeEventListener('scroll', onScroll, { passive: true });
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.setTimeout(show, 9000);

    var dismiss = nudge.querySelector('[data-locale-nudge-dismiss]');
    if (dismiss) {
      dismiss.addEventListener('click', function () {
        remember('dismissed');
        nudge.setAttribute('hidden', '');
        nudge.remove();
      });
    }

    var go = nudge.querySelector('[data-locale-nudge-go]');
    if (go) {
      go.addEventListener('click', function () {
        remember('ur');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
